import { queryOptions, useQuery } from '@tanstack/react-query'

import { getIsLoggedIn } from '../../auth/utils/getIsLoggedIn'
import { rosarioApi } from '../api/rosarioApi'

const getIsRosarioUserQueryOptions = () =>
  queryOptions({
    queryKey: ['is_rosario_user'],
    queryFn: ({ signal }) => rosarioApi.isRosarioUser({ signal }),
    enabled: getIsLoggedIn(),
  })

export const useIsRosarioUserQuery = () => useQuery(getIsRosarioUserQueryOptions())
